import { render, staticRenderFns } from "./ModalGestisciModifica.vue?vue&type=template&id=1eda5328"
import script from "./ModalGestisciModifica.vue?vue&type=script&lang=js"
export * from "./ModalGestisciModifica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports